import Vid1 from '../images/testimonial/2019 Customer Testimonial Video.mp4'
import Vid2 from '../images/testimonial/Testimonial Video Example _ Client Testimonial _ Sacramento Video Production Videographer.mp4'
import Vid3 from '../images/testimonial/Client Testimonial Video.mp4'
import Vid4 from '../images/testimonial/GoodRx Ad_ Testimonials (1).mp4'
import Vid5 from '../images/testimonial/Consumer Testimonial - Dove - Molly Burke.mp4'
import Vid6 from '../images/testimonial/Hubspot Customer Testimonial.mp4'


export default[
    {
     vid:Vid1,
     text:"I was energetic when wearing it. i couldnt belive i got it they..."
    },
    {
     vid:Vid2,
     text:"its very comfy i bought two, for me and my boyfriend"
    },
    {
     vid:Vid3,
     text:"The great thing about the watch is...ofcourse its beautifulness"
    },
    {
     vid:Vid4,
     text:"I thought it was expensive when they told me about it, until i saw it it was worth it"
    },
    {
     vid:Vid5,
     text:"it is old and classy in a better way. and i like oldiness"
    },
    {
     vid:Vid6,
     text:"it was better than my last watch"
    },
]